module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-illustrations/homeMove.svg?80af44caeb699d5709ff84c47461dccd";